/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module helpers/checker
 */
import { isArray } from "./is-array.js";
/**
 * Check value is String
 */
export function isString(value) {
    return typeof value === 'string';
}
/**
 * Check value is Array of String
 */
export function isStringArray(value) {
    return isArray(value) && isString(value[0]);
}
